import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import React from 'react';


import nunito_Black from '../../src/utils/fonts/Nunito/Nunito-Black.ttf';
import nunito_BlackItalic from '../../src/utils/fonts/Nunito/Nunito-BlackItalic.ttf';
import nunito_Bold from '../../src/utils/fonts/Nunito/Nunito-Bold.ttf';
import nunito_BoldItalic from '../../src/utils/fonts/Nunito/Nunito-BoldItalic.ttf';
import nunito_ExtraBold from '../../src/utils/fonts/Nunito/Nunito-ExtraBold.ttf';
import nunito_ExtraBoldItalic from '../../src/utils/fonts/Nunito/Nunito-ExtraBoldItalic.ttf';
import nunito_ExtraLight from '../../src/utils/fonts/Nunito/Nunito-ExtraLight.ttf';
import nunito_ExtraLightItalic from '../../src/utils/fonts/Nunito/Nunito-ExtraLightItalic.ttf';
import nunito_Italic from '../../src/utils/fonts/Nunito/Nunito-Italic.ttf';
import nunito_Light from '../../src/utils/fonts/Nunito/Nunito-Light.ttf';
import nunito_LightItalic from '../../src/utils/fonts/Nunito/Nunito-LightItalic.ttf';
import nunito_Regular from '../../src/utils/fonts/Nunito/Nunito-Regular.ttf';
import nunito_SemiBold from '../../src/utils/fonts/Nunito/Nunito-SemiBold.ttf';
import nunito_SemiBoldItalic from '../../src/utils/fonts/Nunito/Nunito-SemiBoldItalic.ttf';


import nunitoSans_Black from '../../src/utils/fonts/NunitoSans/NunitoSans-Black.ttf';
import nunitoSans_BlackItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-BlackItalic.ttf';
import nunitoSans_Bold from '../../src/utils/fonts/NunitoSans/NunitoSans-Bold.ttf';
import nunitoSans_BoldItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-BoldItalic.ttf';
import nunitoSans_ExtraBold from '../../src/utils/fonts/NunitoSans/NunitoSans-ExtraBold.ttf';
import nunitoSans_ExtraBoldItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-ExtraBoldItalic.ttf';
import nunitoSans_ExtraLight from '../../src/utils/fonts/NunitoSans/NunitoSans-ExtraLight.ttf';
import nunitoSans_ExtraLightItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-ExtraLightItalic.ttf';
import nunitoSans_Italic from '../../src/utils/fonts/NunitoSans/NunitoSans-Italic.ttf';
import nunitoSans_Light from '../../src/utils/fonts/NunitoSans/NunitoSans-Light.ttf';
import nunitoSans_LightItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-LightItalic.ttf';
import nunitoSans_Regular from '../../src/utils/fonts/NunitoSans/NunitoSans-Regular.ttf';
import nunitoSans_SemiBold from '../../src/utils/fonts/NunitoSans/NunitoSans-SemiBold.ttf';
import nunitoSans_SemiBoldItalic from '../../src/utils/fonts/NunitoSans/NunitoSans-SemiBoldItalic.ttf';


const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

const prestadorTheme = createTheme({
  palette: {
    //paleta primaria
    primary: { main: '#1226AA' },
    black: { main: '#202327' },
    backgroundPrimary: { main: '#F1F2FA' },
    backgroundSecondary: { main: '#E7E9F7' },
    white: {
      main: '#ffffff',
      contrastText: 'rgba(0, 0, 0, 0.87)',
      dark: 'rgb(178, 178, 178)',
      light: 'rgb(255, 255, 255)'
    },

    // escala de grises
    grayMedium: {
      main: '#8F9193',
      light: 'rgb(165, 167, 168)',
      dark: 'rgb(100, 101, 102)',
      contrastText: '#fff'
    },

    grayLight: { main: '#C7C8C8' },
    graySuperLight: { main: '#EEEEEE' },
    gray: { main: '#555555' },

    // paleta secundaria
    lightBlue: { main: '#26C3FF' },
    darkBlue: { main: '#121A52' },
    pinkishRed: { main: '#DF3045' },

    // paleta status
    error: {
      main: '#CD1812',
      contrastText: '#fffefe',
      dark: 'rgb(143, 16, 12)',
      light: 'rgb(215, 70, 65)'
    },
    errorSecondary: { main: '#870F00' },
    errorBackground: { main: '#FFEAED' },
    success: {
      main: '#1C8747',
      contrastText: '#fff',
      dark: 'rgb(19, 94, 49)',
      light: 'rgb(73, 159, 107)'
    },
    successSecondary: { main: '#004A1E' },
    successBackground: { main: '#CDECCD' },
    alert: {
      main: '#FFBA33',
      contrastText: 'rgba(0, 0, 0, 0.87)',
      dark: 'rgb(178, 130, 35)',
      light: 'rgb(255, 199, 91)'
    },
    alertSecondary: { main: '#7C6600' },
    alertBackground: { main: '#FDF8C8' },

    /*
     * para usar la paleta de gradientes, hay que declarar el theme usando:
     * const theme = useTheme();
     * y en el componente a usar hay que declarar el background image invocando a:
     * theme.palette.nombreDelGradiente
     * por ejemplo:
     * <Box sx={{ width: '200px', height: '200px', backgroundImage: theme.palette.greyGradient }}>text</Box>
     */

    blueGradient: 'linear-gradient(to right, #1226AA, #3846CE)',
    greyGradient: 'linear-gradient(to right, #C7C8C8, #EEEEEE)'
  },
  // ! para llamar a los breakpoints, usar por ejemplo [prestadorTheme.breakpoints.between('xs', 'sm')] para coincidir con el rango definido en el Figma como Extra Small
  breakpoints: {
    values: breakpoints
  },
  typography: {
    fontFamily: 'NunitoSansRegular',
    h1: {
      fontFamily: 'NunitoBold',
      fontSize: '48px',
      lineHeight: '50px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '32px',
        lineHeight: '44px'
      }
    },
    h2: {
      fontFamily: 'NunitoBold',
      fontSize: '32px',
      lineHeight: 'auto',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '24px',
        lineHeight: '34px'
      }
    },
    h3: {
      fontFamily: 'NunitoBold',
      fontSize: '24px',
      lineHeight: '34px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '20px',
        lineHeight: '26px'
      }
    },
    h4: {
      fontFamily: 'NunitoBold',
      fontSize: '18px',
      lineHeight: '26px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '18px',
        lineHeight: '26px'
      }
    },
    h5: {
      fontFamily: 'NunitoSemiBold',
      fontSize: '16px',
      lineHeight: '22px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '16px',
        lineHeight: '22px'
      }
    },
    bodyS: {
      fontFamily: 'NunitoSansSemiBold',
      fontSize: '14px',
      lineHeight: '16px',
    },
    bodyM: {
      fontFamily: 'NunitoSansSemiBold',
      fontSize: '12px',
      lineHeight: '16px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '16px',
        fontFamily: 'NunitoSansRegular',
        lineHeight: '26px',
      }
    },
    boldBodyS: {
      fontFamily: 'NunitoSansBold',
      fontSize: '14px',
      lineHeight: '18px',
    },
    boldBodyM: {
      fontFamily: 'NunitoSansBold',
      fontSize: '12px',
      lineHeight: '16px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '16px',
        lineHeight: '26px'
      }
    },
    legalS: {
      fontFamily: 'NunitoSansSemiBold',
      fontSize: '9px',
      lineHeight: '14px',
    },
    legalM: {
      fontFamily: 'NunitoSansSemiBold',
      fontSize: '12px',
      lineHeight: '16px',
    },
    callToAction: {
      fontFamily: 'NunitoBold',
      fontSize: '16px',
      lineHeight: '22px',
    },
    textLink: {
      fontFamily: 'NunitoSansBold',
      fontSize: '12px',
      lineHeight: '20px',
      [`@media (min-width:${breakpoints.md}px)`]: {
        fontSize: '14px'
      }
    },
    tabs: {
      fontFamily: 'NunitoSansBold',
      fontSize: '16px',
      lineHeight: '22px',
    },
    lists: {
      fontFamily: 'NunitoSansSemiBold',
      fontSize: '14px',
      lineHeight: '19px',
    },
    button: {
      textTransform: 'none',
      fontFamily: 'NunitoSansBold',
      fontSize: '16px',
      lineHeight: '22px',
    }
  },

  components: {
    MuiStepper: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-root": {
            padding: 0,
            height: '24px'
          },
          "& .MuiStepConnector-root": {
            marginLeft: "11px"
          },
          "& .MuiStepConnector-line": {
            borderColor: "#E7E9F7",
            borderLeftWidth: "2px"
          },
          "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
            borderColor: "#1226AA",
          },
          "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
            borderColor: "#1226AA",
          },
          "& .MuiStepIcon-root": {
            color: "transparent",
            border: "2px solid #E7E9F7",
            borderRadius: "100%",
          },
          "& .MuiStepIcon-root.Mui-active": {
            color: "#1226AA",
            backgroundColor: "#1226AA",
            border: "2px solid #1226AA",
            '& .MuiStepIcon-text': {
              fill: '#FFF',
              fontWeight: 800
            }
          },
          "& .MuiStepIcon-root.Mui-completed": {
            color: "#E7E9F7",
            border: "2px solid #1226AA",
            '& .MuiStepIcon-text': {
              fill: '#1226AA',
              fontWeight: 800
            }
          },
          "& .MuiStepIcon-text": {
            fill: "#8F9193",
            fontWeight: 800,
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          notched: false,
          fontSize: "12px",
          fontWeight: '600',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, 6px)', // Adjust label position when shrunk
          },
          '&.Mui-focused': {
            color: '#555555',
          },
          '&.Mui-error': {
            color: '#555555',
          },
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },

      styleOverrides: {
        root: {
          height: '54px',
          borderRadius: "16px",
          '& .MuiOutlinedInput-input': {
            padding: '16px',
            fontSize: "16px",
            transform: 'translateY(8px)',
            fontFamily: 'NunitoSemiBold',
            lineHeight: '22px',
            [`@media (min-width:${breakpoints.md}px)`]: {
              fontSize: '16px',
              lineHeight: '22px',
            }
          },
          '.MuiOutlinedInput-notchedOutline': {
            borderWidth: "2px",
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#202327',
          },
        },
        // input: {
        //   fontFamily: 'NunitoSansSemiBold',
        //   fontSize: '14px',
        //   lineHeight: '19px',
        // }
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#202327',
          color: '#FFFFFF',
          padding: '1px, 6px, 1px, 6px'
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          '&.MuiButton-outlined': {
            border: '2px solid #1226AA'
          },
        },
        contained: {
          '&.Mui-disabled': {
            background: "#8F9193",
            color: "#FFFFFF"
          }
        },
        text: {
          '&.Mui-disabled': {
            color: "#555555",
          }
        }
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
      
      @font-face {
        font-family: 'NunitoBlack';
        src: url('${nunito_Black}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoBlackItalic';
        src: url('${nunito_BlackItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

        @font-face {
        font-family: 'NunitoBold';
        src: url('${nunito_Bold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

      @font-face {
        font-family: 'NunitoBoldItalic';
        src: url('${nunito_BoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoExtraBold';
        src: url('${nunito_ExtraBold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoExtraBoldItalic';
        src: url('${nunito_ExtraBoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoExtraLight';
        src: url('${nunito_ExtraLight}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoExtraLightItalic';
        src: url('${nunito_ExtraLightItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoItalic';
        src: url('${nunito_Italic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoLight';
        src: url('${nunito_Light}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoLightItalic';
        src: url('${nunito_LightItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoRegular';
        src: url('${nunito_Regular}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSemiBold';
        src: url('${nunito_SemiBold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSemiBoldItalic';
        src: url('${nunito_SemiBoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

      /* CAMBIA FONTS A NUNITO SANS */


        @font-face {
        font-family: 'NunitoSansBlack';
        src: url('${nunitoSans_Black}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
       
      @font-face {
        font-family: 'NunitoSansBlackItalic';
        src: url('${nunitoSans_BlackItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansBold';
        src: url('${nunitoSans_Bold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansBoldItalic';
        src: url('${nunitoSans_BoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansExtraBold';
        src: url('${nunitoSans_ExtraBold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansExtraBoldItalic';
        src: url('${nunitoSans_ExtraBoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansExtraLight';
        src: url('${nunitoSans_ExtraLight}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansExtraLightItalic';
        src: url('${nunitoSans_ExtraLightItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansItalic';
        src: url('${nunitoSans_Italic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansLight';
        src: url('${nunitoSans_Light}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
        @font-face {
        font-family: 'NunitoSansLightItalic';
        src: url('${nunitoSans_LightItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

       @font-face {
        font-family: 'NunitoSansRegular';
        src: url('${nunitoSans_Regular}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
         @font-face {
        font-family: 'NunitoSansSemiBold';
        src: url('${nunitoSans_SemiBold}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
         @font-face {
        font-family: 'NunitoSansSemiBoldItalic';
        src: url('${nunitoSans_SemiBoldItalic}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }

      `
    },
  }
});

function CustomTheme({ children }) {
  return (
    <ThemeProvider theme={prestadorTheme}>
      {' '}
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default CustomTheme;
